import InAppRoutes from 'pages/main/inApp';
import RestrictedInAppRoutes from 'pages/main/restricted';
import { Outlet, Route } from 'react-router';
import { LoggedUserType } from 'zustand-store/types';

const MainRoutes = (loggedUser: LoggedUserType) => <Route path='*' element={<Outlet />}>
    {loggedUser.hasToChangePassword ? RestrictedInAppRoutes : InAppRoutes}
</Route>

export default MainRoutes;